export var Role;
(function (Role) {
    Role["ASSISTANT"] = "assistant";
    Role["USER"] = "user";
    Role["SYSTEM"] = "system";
})(Role || (Role = {}));
export var Status;
(function (Status) {
    Status["OK"] = "ok";
    Status["PERSONAL"] = "personal";
    Status["INAPPROPRIATE"] = "inappropriate";
    Status["UNKNOWN"] = "unknown";
})(Status || (Status = {}));
